import register from '@kpsys/angularjs-register';

import ngAsyncDecoratorHelperModule from '../../utils/ng-@decorators';

import LoginDataService from './kp-login.data-service';
import LoginComponent from './kp-login.component';
import CasLoginSystemComponent from './login-systems/cas/cas.login-system.component';
import EzakLoginSystemComponent from './login-systems/ezak/ezak.login-system.component';
import InternalLoginSystemComponent from './login-systems/internal/internal.login-system.component';
import LdapLoginSystemComponent from './login-systems/ldap/ldap.login-system.component';
import Saml2LoginSystemComponent from './login-systems/saml2/saml2.login-system.component';
import GoogleLoginSystemComponent from './login-systems/google/google.login-system.component';
import BankIDLoginSystemComponent from './login-systems/bankid/bankid.login-system.component';
import MojeIDLoginSystemComponent from './login-systems/mojeid/mojeid.login-system.component';

// @ts-ignore Special webpack function `require.context`
const context = require.context('ng-compile-component/src', false, /\.js$/);
context.keys().forEach((file) => context(file));

export default register('portaro.shared.login.kp-login', [ngAsyncDecoratorHelperModule, 'rckd.utils'])
    .service(LoginDataService.serviceName, LoginDataService)
    .component(LoginComponent.componentName, LoginComponent)
    // login systems components
    .component(BankIDLoginSystemComponent.componentName, BankIDLoginSystemComponent)
    .component(CasLoginSystemComponent.componentName, CasLoginSystemComponent)
    .component(EzakLoginSystemComponent.componentName, EzakLoginSystemComponent)
    .component(GoogleLoginSystemComponent.componentName, GoogleLoginSystemComponent)
    .component(InternalLoginSystemComponent.componentName, InternalLoginSystemComponent)
    .component(LdapLoginSystemComponent.componentName, LdapLoginSystemComponent)
    .component(MojeIDLoginSystemComponent.componentName, MojeIDLoginSystemComponent)
    .component(Saml2LoginSystemComponent.componentName, Saml2LoginSystemComponent)
    .name();
